import { render } from "./UserLicenseManageForm.vue?vue&type=template&id=98682558&scoped=true"
import script from "./UserLicenseManageForm.vue?vue&type=script&lang=js"
export * from "./UserLicenseManageForm.vue?vue&type=script&lang=js"

import "./UserLicenseManageForm.vue?vue&type=style&index=0&id=98682558&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98682558"]])

export default __exports__